import Tooltip from "@mui/material/Tooltip";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    Modal,
    IconButton, Link, TextField, Button
} from "@mui/material";
import { Download } from "@mui/icons-material";
export const styles = {
    iconButton: {
        position: "absolute",
        top: "10px",
        right: "10px",
        backgroundColor: "#fff",
        "&:hover": { backgroundColor: "#ddd" },
        zIndex: 2,
    },
    headerCell: {
        fontWeight: "bold",
        textAlign: "center",
    },
    cell: {
        textAlign: "center",
    },
    dialogPaper: {
        borderRadius: "12px",
        backgroundColor: "#fff",
    },
    dialogContent: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        padding: "20px 0",
        minHeight: "50vh",
    },
    prevButton: {
        position: "absolute",
        left: "10px",
        zIndex: 1,
        backgroundColor: "#fff",
        "&:hover": { backgroundColor: "#ddd" },
        top: "50%",
        transform: "translateY(-50%)",
    },
    nextButton: {
        position: "absolute",
        right: "10px",
        zIndex: 1,
        backgroundColor: "#fff",
        "&:hover": { backgroundColor: "#ddd" },
        top: "50%",
        transform: "translateY(-50%)",
    },
    image: {
        maxWidth: "50%",
        maxHeight: "50vh",
        objectFit: "contain",
        borderRadius: "8px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
        margin: "10px 0",
    },
    noImage: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "200px",
    },
    cardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },
    cardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
        marginBottom: -5,
    },
    typography: {
        fontSize: 15,
    },
    formControl: {
        maxWidth: 220,
        minWidth: 220,
        marginTop: 1,
        marginBottom: 1,
    },
    select: {
        fontSize: 15,
    },
    menuItem: {
        fontSize: 15,
    },
    creationDateSelect: {
        maxWidth: 240,
        minWidth: 240,
        fontSize: 15,
        marginTop: 1,
        marginBottom: 1,
        whiteSpace: "normal",
        wordWrap: "break-word",
        overflow: "hidden",
    },
    filterButtonContainer: {
        marginTop: 1.5,
        justifyContent: "center",
        alignItems: "center",
        padding: 2,
    },
    loaderOverlay: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10
    },
    filterCard: {
        backgroundColor: "#EEF2F7",
        padding: "1.3rem",

    },
    filterCardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
        marginBottom: -5
    },
    locationsCard: {
        maxWidth: 220,
        minWidth: 220,
        marginTop: 1,
        marginBottom: 1

    },
    fontSizeFiftin: {
        fontSize: 15
    },
    transferReqCard: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },
    tableCardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
    },
    parentBox: {
        backgroundColor: "#EEF2F7",
    },
    filterDataButton: {
        marginTop: 1.5,
        justifyContent: "center",
        alignItems: 'center',
        padding: 2
    },
    refreshPageCard: {
        backgroundColor: "#EEF2F7",
        padding: "1.3rem",
    },
    datePickerDiv: {
        maxWidth: 240,
        minWidth: 240,
        fontSize: 15,
        marginTop: 1,
        marginBottom: 1,
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        overflow: 'hidden'
    },
    assetMasterContainer: {
        backgroundColor: "#EEF2F7"
    },
    title: {
        marginLeft: 10,
        fontWeight: 'bold',
    },
    divider: {
        borderBottomWidth: 1,
        height: 5,
    },
    dwnldAssetMasterStyle: {
        marginTop: 2,
        marginBottom: 2,
        marginLeft: 3,
    },
    assetmasterCardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },
    assetmasterCard: {
        backgroundColor: "#EEF2F7",
        padding: "1.3rem",
    },
    assetmasterCardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
    },
    locContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
    },
    dwnldAssetMasterbttnStyle: {
        display: 'flex',
        justifyContent: { xs: 'flex-start', sm: 'center' },
        alignItems: 'center', justifyContent: 'flex-start'
    },
    inputStyle: {
        width: { xs: '100%', sm: 'auto' }
    },
    titleTypography: {
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "16px",
        color: "#0160F1",
    },
    assetMasterloaderOverlay: {
        position: 'absolute',
        top: '50%',
        left: '55%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10
    },
    clearFilterTxt: {
        fontWeight: 'bold',
        color: "#0160F1",
        textDecoration: 'underline'
    }

};


export default styles;
const HoverCell = ({ value }) => {
    return (
        <Tooltip
            title={
                <span style={{ fontSize: "16px" }}>{value}</span>
            }
        >
            <div
                style={{
                    whiteSpace: "none",
                    textAlign: "start",
                    maxWidth: "100%",
                }}
            >{value}</div>
        </Tooltip>
    );
};

export const columns = (handleDownloadInvoice, handleDownloadEwb, handleViewDataClick, handleImage) => [
    { field: 'log_id', headerName: 'Request Id', flex: 0.8 },
    {
        field: 'order_no', headerName: 'TO Number', flex: 0.85, renderCell: (params) => {
            return <HoverCell value={params.value} />;
        },
    },
    {
        field: 'from_loc_name', headerName: 'From Location', flex: 1.3,
        renderCell: (params) => {
            return <HoverCell value={params.value} />;
        }
    },
    {
        field: 'to_loc_name', headerName: 'To Location', flex: 1,
        renderCell: (params) => {
            return <HoverCell value={params.value} />;
        },
    },
    {
        field: 'create_date', headerName: 'Create Date', flex: 1, headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'asset_count', headerName: 'Asset Count', flex: 0.7, headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'view_image',
        headerName: 'Image',
        headerAlign: 'center',
        align: 'center',
        flex: 1.1,
        renderCell: (params) => (
            <Button
                size="small"
                onClick={() => handleImage(params.row)}
            >
                View Image
            </Button>
        ),
    },
    {
        field: 'asset_details',
        headerName: 'Asset Details',
        headerAlign: 'center',
        align: 'center',
        flex: 1.1,
        renderCell: (params) => (
            <Button
                size="small"
                onClick={() => handleViewDataClick(params.row)}
            >
                View Assets
            </Button>
        ),
    },
    {
        field: 'to_value', headerName: 'TO Value', flex: 1, align: "center", headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'uploder_name', headerName: 'Uploader Name',

        flex: 1.2,
        renderCell: (params) => {
            return <HoverCell value={params.value} />;
        },
    },

    {
        field: 'invoice_url', headerAlign: 'center',
        align: 'center', headerName: (
            <div style={{ fontSize: "14px", lineHeight: "1.1" }}>
                <div>Tax invoice /</div>
                <div>Delivery Challan</div>
            </div>
        ), flex: 1.1, align: "center",
        renderCell: (params) =>
            params.row.invoice_url == null || params.row.invoice_url?.length === 0 ? (
                <IconButton disabled>
                    <Download color="disabled" />
                </IconButton>
            ) : (

                <IconButton
                    aria-label="Download"
                    onClick={() => handleDownloadInvoice(params.row.invoice_url)}
                >

                    <Download color="primary" />
                </IconButton>
            ),
    },

    {
        field: 'ewb_url', headerName: 'EWB', flex: 0.8, headerAlign: 'center',
        align: 'center',
        renderCell: (params) =>
            params.row.ewb_url == null || params.row.ewb_url?.length === 0 ? (
                <IconButton disabled>
                    <Download color="disabled" />
                </IconButton>
            ) : (

                <IconButton
                    aria-label="Download"
                    onClick={() => handleDownloadEwb(params.row.ewb_url)}
                >

                    <Download color="primary" />
                </IconButton>
            ),
    },

];
